import { AuthInterface } from "@actassa/api";

export class Login {
    public static readonly type = '[RootState] Login';

    constructor(public payload: AuthInterface) {}
}
